import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/enhanced/data-grid';
import { NotOperatorRoles } from 'shared/permissions/roles';
import TenantPage from 'layouts/TenantPage';
import { useTranslation } from 'react-i18next';
import { categoryService } from 'shared/services';
import { useAppSelector } from 'store/store';
import { useCategoriesColumns } from '../hooks/useCategoriesColumns';
import { AddButton } from 'components/ui';

export const Categories = () => {
  const { t } = useTranslation();
  const translationPrefix = 'pages.category.list';

  const groups = useAppSelector((state) => state.auth.groups);

  const columns: GridColDef[] = useCategoriesColumns(
    NotOperatorRoles.some((role) => groups.includes(role))
  );

  return (
    <TenantPage
      title={t(`${translationPrefix}.title`)}
      subtitle={t(`${translationPrefix}.subtitle`)}
      pageType="categories"
      menuRight={<AddButton prefix={translationPrefix} to="new" requireTenantAdmin />}>
      <EnhancedDataGrid columns={columns} service={categoryService} disableExport={true} />
    </TenantPage>
  );
};
